var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var rlp = require('rlp-encoding');

var Events = require('events');

var _require = require('./constants'),
    SHH_BLOOM = _require.SHH_BLOOM,
    SHH_MESSAGE = _require.SHH_MESSAGE,
    SHH_P2PMSG = _require.SHH_P2PMSG,
    SHH_STATUS = _require.SHH_STATUS;

var Envelope = require('./envelope');

var SHH =
/*#__PURE__*/
function () {
  "use strict";

  function SHH(version, peer, send) {
    _classCallCheck(this, SHH);

    this.version = version;
    this.peer = peer;
    this.send = send;
    this.events = new Events();
  }

  _createClass(SHH, [{
    key: "_handleMessage",
    value: function _handleMessage(code, data) {
      var _this = this;

      var payload = rlp.decode(data);
      if (code === SHH_STATUS) this.events.emit('status', payload); // Bloom filter

      if (code === SHH_BLOOM) this.events.emit('bloom_exchange', payload);

      if (code === SHH_MESSAGE || code === SHH_P2PMSG) {
        payload.forEach(function (envelope) {
          // TODO: replace with envelope or decrypted fields, whatever abstraction makes more sense
          var peer = "enode://" + _this.peer._remoteId.toString('hex') + "@" + _this.peer._socket._peername.address + ":" + _this.peer._socket._peername.port;

          _this.events.emit('message', new Envelope(envelope), peer);
        });
      }
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(code, payload) {
      this.send(code, payload);
    }
  }]);

  return SHH;
}();

module.exports = {
  default: SHH,
  SHH_BLOOM: SHH_BLOOM,
  SHH_MESSAGE: SHH_MESSAGE,
  SHH_STATUS: SHH_STATUS
};